import script from "./VersesDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./VersesDisplay.vue?vue&type=script&setup=true&lang=js"

import "./VersesDisplay.vue?vue&type=style&index=0&id=0a42d0b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a42d0b2"]])

export default __exports__